import { render, staticRenderFns } from "./preset-book.component.vue?vue&type=template&id=07df5e2e&scoped=true"
import script from "./preset-book.component.vue?vue&type=script&lang=ts"
export * from "./preset-book.component.vue?vue&type=script&lang=ts"
import style0 from "./preset-book.style.scss?vue&type=style&index=0&id=07df5e2e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07df5e2e",
  null
  
)

export default component.exports